import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddRole, EditRole } from '../store/capabilities.actions';
import { GetRoles } from '../../user-management/store/user-managment.actions';
import { Location } from '@angular/common';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss']
})
export class AddRoleComponent implements OnInit {
  addRoleForm: FormGroup;
  categories: Array<string> = [];
  roleDetails: any;
  selectedCategory: string;
  roleKey: string;
  formTitle: string;
  validationMsg = VALIDATION_MESSAGES;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private fb: FormBuilder,
    private location: Location,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.roleDetails = JSON.parse(this.activatedRoute.snapshot.params['roleDetails']);
    this.formTitle = this.activatedRoute.snapshot.params['title'];

    if (Object.keys(this.roleDetails).length) {
      this.addRoleForm = this.fb.group({
        role: [this.roleDetails.role, Validators.required],
        roleName: [this.roleDetails.roleName, Validators.compose([
          Validators.required,
          ValidationUtil.cannotBeBlank,
        ])],
        description: [this.roleDetails.description || ""],
        category: [this.roleDetails.category, Validators.required]
      });
    } else {
      this.addRoleForm = this.fb.group({
        role: ['', Validators.required],
        roleName: ['', Validators.compose([
          Validators.required,
          ValidationUtil.cannotBeBlank,
        ])],
        description: [''],
        category: ['', Validators.required],
      });
    }

    this.store.dispatch(new GetRoles());
    this.store.select(state => state.userManagment.roles).pipe().subscribe(response => {
      if (response.status) {
        const categories = response.roles.map(role => role.category);
        this.categories = Array.from(new Set(categories));

        if (typeof this.roleDetails.category != "undefined") {
          this.selectedCategory = this.roleDetails.category;
        }
      }
    });
    this.addRoleForm.get('roleName').valueChanges.subscribe((value) => {
      const hasSpecialchars = new RegExp('^[a-zA-Z0-9]+$');
      let alteredValue = Array.from(value.trim())
      .filter((ele: any) => (!hasSpecialchars.test(ele)) ? '' : value).join('').replace(/ +/g, '');
      this.addRoleForm.controls['role'].setValue(alteredValue.toLowerCase());
    });
  }

  addRole() {
    const data = this.addRoleForm.value;
    const payload = {
     // role: data.role.trim(),
      roleName: data.roleName.trim(),
      description: data.description.trim(),
      category: data.category,
    }
    if (!Object.keys(this.roleDetails).length) {
      this.store.dispatch(new AddRole(payload));
      this.store.select(state => state.capabilities.addRoleRespone).pipe().subscribe(response => {
        // this.goBack();
      });
    } else {
      this.roleKey = this.roleDetails.role;
      this.store.dispatch(new EditRole(this.roleKey, payload));
      this.store.select(state => state.capabilities.editRoleResponse).pipe().subscribe(response => {
        // this.goBack();
      });
    }
  }

  goBack() {
    this.router.navigate(['home', 'role-management', 'list-capabilities']);
  }

  cancel() {
    this.location.back();
  }
}
